import { StatusLicitacao } from '../../../../model/apm/apm-enums';

export const BIDDING_STATUS_COLOR: Record<StatusLicitacao, 'info' | 'success' | 'warning' | 'error' | 'default'> = {
    [StatusLicitacao.EmAndamento]: 'info',
    [StatusLicitacao.Homologada]: 'success',
    [StatusLicitacao.Encerrada]: 'default',
    [StatusLicitacao.Suspensa]: 'warning',
    [StatusLicitacao.Deserta]: 'warning',
    [StatusLicitacao.Frustrada]: 'warning',
    [StatusLicitacao.Anulada]: 'error',
    [StatusLicitacao.Cancelada]: 'error',
    [StatusLicitacao.Revogada]: 'error',
};
